export const environments = {
  SANDBOX: "sandbox",
  PRODUCTION: "production",
};

export const paymentTypes = {
  CHECKOUT: "checkout",
  STRIPE: "stripe",
};

export const IASessionSteps = {
  VERIFY_INFO: {
    name: "VERIFY_INFO",
    order: 1,
  },
  APPLICATION_QUESTIONS: {
    name: "APPLICATION_QUESTIONS",
    order: 2,
  },
  ESIGNATURE_DOCUMENT: {
    name: "ESIGNATURE_DOCUMENT",
    order: 3,
  },
  ADD_CARD_DETAILS: {
    name: "ADD_CARD_DETAILS",
    order: 4,
  },
  FINAL_REVIEW: {
    name: "FINAL_REVIEW",
    order: 5,
  },
  APPLICATION_COMPLETE: {
    name: "APPLICATION_COMPLETE",
    order: 6,
  },
};

export const gqlErrors = {
  PAYMENT_NOT_AUTHORIZED: "PAYMENT_NOT_AUTHORIZED",
  // Raised by saveAndStepForward / saveAndStepBack when the session is already
  // in APPLICATION_COMPLETE (post-completion lockout). Surfaced via the
  // top-level errors[] array, not data.<mutation>.ok.
  APPLICATION_ALREADY_COMPLETED: "APPLICATION_ALREADY_COMPLETED",
  // Raised by saveAndStepForward when a standard / agency-pay session tries to
  // advance to APPLICATION_COMPLETE on its own (from FINAL_REVIEW). The terminal
  // transition is owned exclusively by bindInsurancePolicy.
  POLICY_BIND_REQUIRED: "POLICY_BIND_REQUIRED",
  // Raised by the apply flow when the contractor is blocked from writes.
  CONTRACTOR_BLOCKED_FOR_WRITES: "CONTRACTOR_BLOCKED_FOR_WRITES",
};

export const pusherEvents = {
  COI_GENERATED: "coi-generated",
};
